<template>

    <authentication-layout :title="__('Reset Password')">

        <validation-errors class="mb-4" />

        <form @submit.prevent="submit">

            <Input class="block w-full mb-3"
                id="email"
                type="email"
                :placeholder="__('Email')"
                v-model="form.email"
                required
                autofocus
            />

            <Input class="block w-full mb-3"
                id="password"
                type="password"
                :placeholder="__('Password')"
                v-model="form.password"
                required
                autocomplete="new-password"
            />

            <Input class="block w-full mb-3"
                id="password_confirmation"
                type="password"
                :placeholder="__('Confirm Password')"
                v-model="form.password_confirmation"
                required
                autocomplete="new-password"
            />

            <div class="flex justify-start items-center">

                <Button class="mt-3"
                    :class="{ 'opacity-25': form.processing }"
                    :disabled="form.processing">

                    {{ __('Reset Password') }}

                </Button>

            </div>
        </form>

    </authentication-layout>

</template>

<script>
    import { defineComponent } from 'vue';
    import AuthenticationLayout from "@/Layouts/AuthenticationLayout";
    import Button from '@/Components/Button.vue'
    import Input from '@/Components/Input.vue'
    import Label from '@/Components/Label.vue'
    import ValidationErrors from '@/Components/ValidationErrors.vue'

    export default defineComponent({
        components: {
            AuthenticationLayout,
            Button,
            Input,
            Label,
            ValidationErrors
        },

        props: {
            email: String,
            token: String,
        },

        data() {
            return {
                form: this.$inertia.form({
                    token: this.token,
                    email: this.email,
                    password: '',
                    password_confirmation: '',
                })
            }
        },

        methods: {
            submit() {
                this.form.post(this.route('password.update'), {
                    onFinish: () => this.form.reset('password', 'password_confirmation'),
                })
            }
        }
    })
</script>
